var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_160_493)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1665 7.8344C10.1662 8.45321 9.92004 9.04656 9.48225 9.4839C9.04447 9.92125 8.45088 10.1668 7.83207 10.1665C7.21326 10.1662 6.61991 9.92004 6.18256 9.48225C5.74522 9.04447 5.49969 8.45088 5.5 7.83207C5.50031 7.21326 5.74643 6.61991 6.18421 6.18256C6.622 5.74522 7.21559 5.49969 7.8344 5.5C8.45321 5.50031 9.04656 5.74643 9.4839 6.18421C9.92125 6.622 10.1668 7.21559 10.1665 7.8344ZM10.2365 11.8942H5.57V26.5003H10.2365V11.8942ZM17.6095 11.8942H12.9663V26.5003H17.5628V18.8356C17.5628 14.5658 23.1276 14.1691 23.1276 18.8356V26.5003H27.7357V17.249C27.7357 10.051 19.4994 10.3193 17.5628 13.8541L17.6095 11.8942Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_160_493"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.10756fc78251864ebade46f6b3fe42dc.svg";
export { ForwardRef as ReactComponent };